import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiGoogleExchange } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

/**
 * Receives Emergent OAuth fragment (#session_id=...) → exchanges it
 * with the backend → redirects to dashboard.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      const sessionId = m ? decodeURIComponent(m[1]) : null;
      if (!sessionId) {
        toast.error("Missing Google session id");
        navigate("/login", { replace: true });
        return;
      }
      try {
        await apiGoogleExchange(sessionId);
        await refresh();
        // Clean the fragment
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google login failed");
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, refresh]);

  return (
    <section className="pt-32 text-center" data-testid="auth-callback">
      <div className="text-sm font-mono uppercase tracking-[0.3em] text-neutral-500">
        Signing you in…
      </div>
    </section>
  );
}
